/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import classnames from 'classnames';
import * as React from 'react';

import { IHeadingProps } from './Heading.props';

/**
 * Heading component.
 * @extends {React.PureComponent<IPriceProps>}
 */

const Heading = ({ headingTag: HTag = 'h1', tag: Tag, className, text }: IHeadingProps) =>
    Tag ? <Tag className={classnames(className)}>{text}</Tag> : <HTag className={classnames(className)}>{text}</HTag>;

export default Heading;
